module.exports = __webpack_public_path__ + "dda82f67677e2fab343b077d8d4cc820.svg";